import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { Analytics, GTM, EventHub } from '@miro-site/analytics';
var analytics = new Analytics();

var getAnalytics = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var providers, eventHubUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (analytics.isInitalized) {
              _context.next = 6;
              break;
            }

            providers = [];

            if (process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID) {
              providers.push( // Init GTM
              new GTM(process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID, process.env.NEXT_PUBLIC_ANALYTICS_GTM_AUTH || '', 'env-5', 'x', 'dataLayer', {}, {}));
            }

            if (process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_ENDPOINT && process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_AUTH) {
              eventHubUrl = process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_URL || '';
              providers.push(new EventHub(eventHubUrl, process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_AUTH, process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_ENDPOINT));
            }

            _context.next = 6;
            return analytics.initialize(providers);

          case 6:
            return _context.abrupt("return", analytics);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAnalytics() {
    return _ref.apply(this, arguments);
  };
}();

export default getAnalytics;